<template>
  <div id="app">
    <van-tabbar v-model="active" v-if="showTabbar">
      <van-tabbar-item replace  icon="friends-o" @click="infoClick()">产品信息</van-tabbar-item>
      <van-tabbar-item replace icon="setting-o" @click="productClick()">生产溯源</van-tabbar-item>
      <van-tabbar-item replace icon="home-o" @click="companyClick()">生产厂家</van-tabbar-item>
    </van-tabbar>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return{
      active: 0,
    }
  },
  computed: {
    isHl() {
      return this.$route.path.indexOf('/hl/') === 0;
    },
    showTabbar() {
      return this.$route.path.indexOf('/repair') === -1;
    }
  },
  watch:{
    $route: {
      immediate: true,
      handler(to) {
        if (to.path.indexOf('product') !== -1) {
          this.active = 1;
        } else if (to.path.indexOf('company') !== -1) {
          this.active = 2;
        } else {
          this.active = 0;
        }
      }
    }
  },
  methods:{
    infoClick(){
      if(sessionStorage.getItem('id')){
        this.$router.push({
          path: this.isHl ? '/hl/info' : '/info',
          query:{
            id:sessionStorage.getItem('id'),
          }
        })
      }
    },
    productClick(){
      if(sessionStorage.getItem('id')){
        this.$router.push({
          path: this.isHl ? '/hl/product' : '/product',
          query:{
            id:sessionStorage.getItem('id'),
          }
        })
      }
    },
    companyClick(){
      if(sessionStorage.getItem('id')){
        this.$router.push({
          path: this.isHl ? '/hl/company' : '/company',
          query:{
            id:sessionStorage.getItem('id'),
          }
        })
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue